import { createContext, createElement, type ReactNode, useContext, useLayoutEffect } from "react";

export type Language = "en" | "fr";

const LanguageContext = createContext<Language>("en");

const FR: Record<string, string> = {
  Account: "Compte",
  Action: "Action",
  "Action timeline": "Chronologie des actions",
  Activity: "Activité",
  "Actions directly targeting this record.": "Actions ciblant directement cet enregistrement.",
  "Action type": "Type d’action",
  "Active filters": "Filtres actifs",
  Actor: "Intervenant",
  Address: "Adresse",
  After: "Après",
  "All clear": "Tout est en ordre",
  "All games": "Tous les jeux",
  "All movements": "Tous les mouvements",
  "All platform currencies": "Toutes les devises de la plateforme",
  "All statuses": "Tous les statuts",
  Amount: "Montant",
  Angle: "Angle",
  "Apply filters": "Appliquer les filtres",
  Approval: "Approbation",
  "Approval queue": "File d’approbation",
  Approvals: "Approbations",
  Approve: "Approuver",
  "Approve this request": "Approuver cette demande",
  Approved: "Approuvé",
  "Attention needed": "Attention requise",
  Audience: "Audience",
  Audit: "Audit",
  "Audit event": "Événement d’audit",
  "Audit log": "Journal d’audit",
  "Audit log viewed": "Journal d’audit consulté",
  Balanced: "Équilibré",
  Ban: "Bannir",
  "Ban this account": "Bannir ce compte",
  Before: "Avant",
  "Bet partially settled": "Mise partiellement réglée",
  "Bet placed": "Mise placée",
  "Bet returned": "Mise retournée",
  "Bet settled": "Mise réglée",
  Blackjack: "Blackjack",
  "Blackjack round void": "Manche de blackjack annulée",
  "Blackjack table result": "Résultat de la table de blackjack",
  Bonus: "Bonus",
  "Bonus converted": "Bonus converti",
  "Bonus grant": "Attribution de bonus",
  Cancel: "Annuler",
  "Card history unavailable": "Historique des cartes indisponible",
  "Case note added": "Note de dossier ajoutée",
  "Casino Profit": "Produit du casino",
  "Casino profit report viewed": "Rapport du produit du casino consulté",
  "Chain verification failed": "Échec de la vérification de la chaîne",
  "Checking…": "Vérification…",
  Clear: "Effacer",
  Close: "Fermer",
  "Close round detail": "Fermer le détail de la manche",
  "Close transaction detail": "Fermer le détail de la transaction",
  Closed: "Fermé",
  "Completed since 00:00 UTC": "Terminées depuis 00:00 UTC",
  "Confirm it’s you": "Confirmez votre identité",
  "Confirms that recorded operator actions have not been altered.":
    "Confirme que les actions enregistrées des opérateurs n’ont pas été modifiées.",
  Copied: "Copié",
  Copy: "Copier",
  "Copy correlation ID": "Copier l’identifiant de corrélation",
  "Copy link": "Copier le lien",
  Correction: "Correction",
  "Could not inspect the round.": "Impossible d’examiner la manche.",
  "Could not re-authenticate.": "Impossible de confirmer votre identité.",
  "Could not load Royal Spin.": "Impossible de charger Royal Spin.",
  "Could not load campaign history.": "Impossible de charger l’historique de la campagne.",
  "Could not load cases.": "Impossible de charger les dossiers.",
  "Could not load casino profit.": "Impossible de charger le produit du casino.",
  "Could not load game history.": "Impossible de charger l’historique des jeux.",
  "Could not load more entries.": "Impossible de charger plus d’entrées.",
  "Could not load more of the log.": "Impossible de charger davantage le journal.",
  "Could not load more players.": "Impossible de charger plus de joueurs.",
  "Could not load operator activity.": "Impossible de charger l’activité des opérateurs.",
  "Could not load player controls.": "Impossible de charger les contrôles du joueur.",
  "Could not load players.": "Impossible de charger les joueurs.",
  "Could not load rounds.": "Impossible de charger les manches.",
  "Could not load sessions.": "Impossible de charger les sessions.",
  "Could not load the dashboard.": "Impossible de charger le tableau de bord.",
  "Could not load the ledger.": "Impossible de charger le grand livre.",
  "Could not load the log.": "Impossible de charger le journal.",
  "Could not load the queue.": "Impossible de charger la file.",
  "Could not load the round.": "Impossible de charger la manche.",
  "Could not load transaction detail.": "Impossible de charger le détail de la transaction.",
  "Could not load transactions.": "Impossible de charger les transactions.",
  "Could not open that player.": "Impossible d’ouvrir ce joueur.",
  "Could not request the reversal.": "Impossible de demander l’annulation.",
  "Could not sign in.": "Connexion impossible.",
  "Could not sign out. Try again.": "Déconnexion impossible. Réessayez.",
  "Created at": "Créé le",
  Creator: "Créateur",
  "Credited to player": "Crédité au joueur",
  Currency: "Devise",
  Dashboard: "Tableau de bord",
  "Dashboard data": "Données du tableau de bord",
  "Dashboard data incomplete": "Données du tableau de bord incomplètes",
  "Date range shortcuts": "Raccourcis de période",
  Dealer: "Croupier",
  "Debited from player": "Débité du joueur",
  Decision: "Décision",
  Deposit: "Dépôt",
  "Deposit limit": "Limite de dépôt",
  Device: "Appareil",
  "Dismiss without acting": "Fermer sans agir",
  "Economy & promotions": "Économie et promotions",
  Effective: "Prise d’effet",
  "Effective window": "Période d’effet",
  Email: "E-mail",
  "Email verified": "E-mail vérifié",
  "Email, display name or id": "E-mail, pseudonyme ou identifiant",
  "Emergency control": "Contrôle d’urgence",
  "Emergency disable": "Désactivation d’urgence",
  "Emergency disabled": "Désactivé en urgence",
  Enabled: "Activé",
  "End every session": "Fermer toutes les sessions",
  "Every live session ends. The player can sign in again straight away.":
    "Toutes les sessions actives prennent fin. Le joueur peut se reconnecter immédiatement.",
  "Every transaction must net to zero.": "Chaque transaction doit avoir un solde net nul.",
  "Exact UUID": "UUID exact",
  Expires: "Expire",
  Field: "Champ",
  "Final hands": "Mains finales",
  Filter: "Filtrer",
  "Fixed-reward expected cost / spin": "Coût attendu de la récompense fixe / tour",
  "Force logout": "Forcer la déconnexion",
  From: "Du",
  "From (UTC)": "Du (UTC)",
  Game: "Jeu",
  "Game history": "Historique des jeux",
  "Game round": "Manche de jeu",
  "Games today": "Jeux aujourd’hui",
  Glossary: "Glossaire",
  "Gross gaming revenue": "Produit brut des jeux",
  "Gross gaming revenue is settled stakes minus player returns.":
    "Le produit brut des jeux correspond aux mises réglées moins les retours joueurs.",
  High: "Élevée",
  Hide: "Masquer",
  "Hide password": "Masquer le mot de passe",
  "ID, email or display name": "Identifiant, e-mail ou pseudonyme",
  Info: "Info",
  Inspect: "Examiner",
  Integrity: "Intégrité",
  "Integrity and technical details": "Intégrité et détails techniques",
  "Initial note": "Note initiale",
  "Investigate →": "Examiner →",
  Justification: "Justification",
  "Just now": "À l’instant",
  Label: "Libellé",
  "Last activity": "Dernière activité",
  "Last seen": "Dernière activité",
  Ledger: "Grand livre",
  Lifecycle: "Cycle de vie",
  "Lifecycle history": "Historique du cycle de vie",
  Limit: "Limite",
  "Live games": "Jeux en direct",
  "Live sessions": "Sessions actives",
  "Load more": "Charger plus",
  "Loading dashboard…": "Chargement du tableau de bord…",
  "Loading game rounds…": "Chargement des manches…",
  "Loading money movements…": "Chargement des mouvements financiers…",
  "Loading operator activity…": "Chargement de l’activité des opérateurs…",
  "Loading the audit log.": "Chargement du journal d’audit.",
  "Loading…": "Chargement…",
  "Loss limit": "Limite de perte",
  Low: "Faible",
  "Maximum amount": "Montant maximal",
  "Maximum deposit-offer exposure": "Exposition maximale de l’offre de dépôt",
  "Minimum amount": "Montant minimal",
  Movement: "Mouvement",
  "Movement detail": "Détail du mouvement",
  "Movement summary": "Résumé du mouvement",
  "New case": "Nouveau dossier",
  "New value": "Nouvelle valeur",
  "Newest rounds first": "Manches les plus récentes d’abord",
  "Never signed in": "Jamais connecté",
  "No account matches that search.": "Aucun compte ne correspond à cette recherche.",
  "No account matches that. Search is by prefix, not by substring.":
    "Aucun compte ne correspond. La recherche porte sur le préfixe, pas sur une sous-chaîne.",
  "No actions recorded.": "Aucune action enregistrée.",
  "No cases have been opened for this player.": "Aucun dossier n’a été ouvert pour ce joueur.",
  "No display name": "Aucun pseudonyme",
  "No games are currently in progress.": "Aucun jeu n’est actuellement en cours.",
  "No games have settled today.": "Aucun jeu n’a été réglé aujourd’hui.",
  "No limit": "Aucune limite",
  "No money movement matches these filters.":
    "Aucun mouvement financier ne correspond à ces filtres.",
  "No operator activity directly targets this record.":
    "Aucune activité d’opérateur ne cible directement cet enregistrement.",
  "No recorded player actions.": "Aucune action de joueur enregistrée.",
  "No round matches these filters.": "Aucune manche ne correspond à ces filtres.",
  "No settled games": "Aucun jeu réglé",
  "No settled gaming activity matches these filters.":
    "Aucune activité de jeu réglée ne correspond à ces filtres.",
  "No settlement movements.": "Aucun mouvement de règlement.",
  "No table": "Aucune table",
  None: "Aucun",
  Normal: "Normale",
  "Not recorded": "Non enregistré",
  "Not revealed": "Non révélé",
  "Not set": "Non défini",
  "Not verified": "Non vérifié",
  "Nothing has changed since registration.": "Rien n’a changé depuis l’inscription.",
  "Nothing is waiting for a decision.": "Aucune décision n’est en attente.",
  "Nothing matches those filters.": "Aucun résultat ne correspond à ces filtres.",
  Odds: "Probabilités",
  Off: "Désactivé",
  Open: "Ouvert",
  Opened: "Ouvert",
  "Open full audit log →": "Ouvrir le journal d’audit complet →",
  "Open queue →": "Ouvrir la file →",
  Operational: "Opérationnel",
  Operations: "Opérations",
  "Operations look healthy": "Les opérations sont saines",
  Operator: "Opérateur",
  "Operator activity": "Activité des opérateurs",
  "Operator ID": "Identifiant opérateur",
  "Operator id": "Identifiant opérateur",
  "Operator record integrity": "Intégrité des enregistrements opérateur",
  "Operator record integrity failed": "Échec de l’intégrité des enregistrements opérateur",
  "Operator reauthenticated": "Opérateur réauthentifié",
  "Operator signed in": "Connexion opérateur",
  "Operator signed out": "Déconnexion opérateur",
  Owner: "Responsable",
  Password: "Mot de passe",
  "Password and code together. There is no registration — the first operator is created from the command line.":
    "Mot de passe et code ensemble. Il n’y a pas d’inscription : le premier opérateur est créé en ligne de commande.",
  Payout: "Paiement",
  "Pending approvals": "Approbations en attente",
  Refresh: "Actualiser",
  "Pending changes": "Modifications en attente",
  "Pending settlement": "Règlement en attente",
  Player: "Joueur",
  "Player case created": "Dossier joueur créé",
  "Player case updated": "Dossier joueur mis à jour",
  "Player email": "E-mail du joueur",
  "Player ID": "Identifiant joueur",
  "Player id": "Identifiant joueur",
  "Player list viewed": "Liste des joueurs consultée",
  "Player operations": "Opérations joueurs",
  "Player sessions ended": "Sessions du joueur terminées",
  "Player status changed": "Statut du joueur modifié",
  Players: "Joueurs",
  "Poker buy-in": "Entrée de poker",
  "Poker cash-out": "Sortie de poker",
  "Poker hand settled": "Main de poker réglée",
  "Poker hand voided": "Main de poker annulée",
  "Poker top-up": "Recharge de poker",
  Priority: "Priorité",
  "Provider settlement": "Règlement fournisseur",
  "RNG evidence is unavailable": "Les preuves RNG sont indisponibles",
  "Raised by": "Demandé par",
  Reason: "Motif",
  "Reality check": "Rappel de réalité",
  Recorded: "Enregistré",
  recorded: "enregistrées",
  "Recorded against the account and in the audit log.":
    "Enregistré sur le compte et dans le journal d’audit.",
  Reference: "Référence",
  "Reference type": "Type de référence",
  Registered: "Inscrit",
  "Re-enable Royal Spin": "Réactiver Royal Spin",
  Reinstate: "Rétablir",
  "Reinstate this account": "Rétablir ce compte",
  Reject: "Rejeter",
  "Reject this request": "Rejeter cette demande",
  Rejected: "Rejeté",
  Requested: "Demandé",
  "Responsible Gaming": "Jeu responsable",
  Returned: "Retourné",
  "Returned stake": "Mise retournée",
  Reversal: "Annulation",
  "Reversal of": "Annulation de",
  "Reversal request sent to the approval queue.":
    "Demande d’annulation envoyée dans la file d’approbation.",
  Review: "À examiner",
  Resolved: "Résolu",
  Risk: "Risque",
  Role: "Rôle",
  Roulette: "Roulette",
  Round: "Manche",
  "Round detail": "Détail de la manche",
  "Round ID": "Identifiant de manche",
  "Round or payment reference": "Référence de manche ou de paiement",
  "Round search": "Recherche de manche",
  Rounds: "Manches",
  "Rounds today": "Manches aujourd’hui",
  Ruleset: "Règles",
  Search: "Rechercher",
  Show: "Afficher",
  "Show password": "Afficher le mot de passe",
  "Search failed.": "Échec de la recherche.",
  Searching: "Recherche",
  "Searching.": "Recherche en cours.",
  "Searching…": "Recherche…",
  Segment: "Segment",
  Session: "Session",
  Sessions: "Sessions",
  "Settled stakes minus player returns": "Mises réglées moins retours joueurs",
  "Settled wagered": "Mises réglées",
  "Sign in": "Se connecter",
  "Sign out": "Se déconnecter",
  "Signed in": "Connecté",
  "Signing in…": "Connexion…",
  "Single player": "Joueur unique",
  Slots: "Machines à sous",
  "Something went wrong.": "Une erreur s’est produite.",
  "Source IP": "IP source",
  Stake: "Mise",
  Started: "Début",
  "Started at": "Démarré le",
  State: "État",
  Status: "Statut",
  Subject: "Objet",
  Support: "Assistance",
  Suspend: "Suspendre",
  "Suspend this account": "Suspendre ce compte",
  System: "Système",
  "System health": "État du système",
  Table: "Table",
  "Table prefix": "Préfixe de table",
  "Take ownership": "Prendre en charge",
  Target: "Cible",
  "Target ID": "Identifiant cible",
  "Target type": "Type de cible",
  "Technical details": "Détails techniques",
  "Test environment: authenticator verification is disabled.":
    "Environnement de test : la vérification de l’authentificateur est désactivée.",
  "That change did not go through.": "La modification a échoué.",
  "That decision did not go through.": "La décision a échoué.",
  "That did not go through.": "L’opération a échoué.",
  "The account can sign in and play again.": "Le compte peut de nouveau se connecter et jouer.",
  "The account is closed to play and every live session ends immediately.":
    "Le compte est fermé au jeu et toutes les sessions actives prennent fin immédiatement.",
  "The log is empty.": "Le journal est vide.",
  "The operation failed.": "L’opération a échoué.",
  "This account has never moved money.": "Ce compte n’a jamais enregistré de mouvement financier.",
  "This account has never signed in.": "Ce compte ne s’est jamais connecté.",
  "This event did not change stored data.":
    "Cet événement n’a pas modifié les données enregistrées.",
  "This player has never held a balance.": "Ce joueur n’a jamais détenu de solde.",
  "This player has not played a round.": "Ce joueur n’a joué aucune manche.",
  Today: "Aujourd’hui",
  "Today's GGR": "PBJ du jour",
  "Today's wagered": "Mises du jour",
  To: "Au",
  "To (UTC)": "Au (UTC)",
  "Total settled stakes": "Total des mises réglées",
  Transaction: "Transaction",
  "Transaction ID": "Identifiant de transaction",
  Transactions: "Transactions",
  "Transactions viewed": "Transactions consultées",
  Transition: "Transition",
  Type: "Type",
  Unassign: "Désattribuer",
  Unassigned: "Non attribué",
  Urgent: "Urgente",
  "Use dark theme": "Utiliser le thème sombre",
  "Use light theme": "Utiliser le thème clair",
  Verified: "Vérifié",
  Version: "Version",
  Wagered: "Misé",
  "Wager limit": "Limite de mise",
  "Waiting for a second operator": "En attente d’un second opérateur",
  "What happened, in a sentence.": "Décrivez ce qui s’est passé en une phrase.",
  When: "Date",
  Who: "Auteur",
  Withdrawal: "Retrait",
  Working: "Traitement",
  "Working…": "Traitement…",
  Yes: "Oui",
  "cooling-off period": "délai de réflexion",
  "newest first, corrections included": "plus récents d’abord, corrections incluses",
  "not yours to decide": "vous ne pouvez pas décider",
  "revoked ones included": "sessions révoquées incluses",
  by: "par",
  open: "ouverte",
  player: "joueur",
  "too late to decide": "délai de décision dépassé",
  "yours to wait on": "en attente d’un autre opérateur",
  "All rounds →": "Toutes les manches →",
  "Audit log →": "Journal d’audit →",
  "Backoffice connection": "Connexion au backoffice",
  "Connected and receiving data": "Connecté et réception des données active",
  "Full report →": "Rapport complet →",
  "Needs attention": "Points à vérifier",
  "No stale rounds, expiring approvals or integrity issues.":
    "Aucune manche bloquée, approbation proche de l’expiration ou anomalie d’intégrité.",
  "Recent operator activity": "Activité récente des opérateurs",
  Updated: "Mis à jour",
  "Updated just now": "Mis à jour à l’instant",
  "View →": "Voir →",
  "just now": "à l’instant",
  now: "maintenant",
  "00:00–now": "00:00–maintenant",
  "· 00:00–now · UTC": "· 00:00–maintenant · UTC",
  "7 days": "7 jours",
  "30 days": "30 jours",
  Abandoned: "Abandonné",
  "Actions List": "Liste des approbations",
  "Activation schedule (UTC)": "Calendrier d’activation (UTC)",
  active: "actif",
  "Approval queue viewed": "File d’approbation consultée",
  "Audited justification": "Justification auditée",
  "Campaign approved for its scheduled activation.":
    "Campagne approuvée pour son activation planifiée.",
  "Campaign configuration": "Configuration de la campagne",
  "Campaign detail": "Détail de la campagne",
  "Campaign submitted for independent approval.":
    "Campagne soumise à une approbation indépendante.",
  cash: "disponible",
  "Chain intact across": "Chaîne intacte sur",
  "Chain broken at": "Chaîne rompue à",
  "Clear all": "Tout effacer",
  created: "créé",
  "Create version": "Créer une version",
  Critical: "Critique",
  "Export CSV": "Exporter en CSV",
  "Internal notes ·": "Notes internes ·",
  "GGR is calculated from settled wallet movements and corrections. NGR is not shown until bonus, payment-provider fee and tax costs have authoritative ledger sources.":
    "Le PBJ est calculé à partir des mouvements de portefeuille réglés et des corrections. Le produit net n’est pas affiché tant que les bonus, frais de paiement et taxes ne disposent pas de sources comptables fiables.",
  "GGR margin": "Marge PBJ",
  Margin: "Marge",
  Medium: "Moyenne",
  "Maker-checker: you cannot approve your own submission.":
    "Séparation des rôles : vous ne pouvez pas approuver votre propre soumission.",
  "New immutable draft": "Nouveau brouillon immuable",
  "Only XTS/test campaigns are accepted. Outcome and conditional weights must each total exactly 10,000 bps.":
    "Seules les campagnes XTS/test sont acceptées. Les pondérations des résultats et des conditions doivent chacune totaliser exactement 10 000 pdb.",
  "Open campaign": "Ouvrir la campagne",
  "Player List": "Liste des joueurs",
  "Player View": "Consultation du joueur",
  "Reports Casino Profit View": "Consultation du rapport du produit du casino",
  reserved: "réservé",
  "Requires a recently reauthenticated admin session and creates an append-only audit record.":
    "Nécessite une session administrateur récemment réauthentifiée et crée une entrée d’audit immuable.",
  "Returned to players": "Retourné aux joueurs",
  "Round Search": "Recherche de manche",
  "Royal Spin campaigns": "Campagnes Royal Spin",
  settled: "réglé",
  Settled: "Réglé",
  "Stop and investigate →": "Arrêter et examiner →",
  Submit: "Soumettre",
  "Approve schedule": "Approuver le calendrier",
  super_admin: "super administrateur",
  "super admin": "super administrateur",
  "Super Admin": "Super administrateur",
  system: "système",
  "system seed": "initialisation système",
  "Transactions View": "Consultation des transactions",
  User: "Utilisateur",
  "Weight total": "Poids total",
  "approvals expire within 30 minutes": "approbations expirent dans moins de 30 minutes",
  bps: "pdb",
  "entries.": "entrées.",
  entries: "entrées",
  movements: "mouvements",
  rounds: "manches",
  "rounds open over 10 minutes": "manches ouvertes depuis plus de 10 minutes",
  Showing: "Affichage de",
  "Reads are recorded as well as writes: opening a player is itself an entry. The chain is verified across the whole log, not across what is filtered here.":
    "Les consultations sont enregistrées comme les modifications : ouvrir un joueur constitue aussi une entrée. La chaîne est vérifiée sur l’ensemble du journal, pas seulement sur les résultats filtrés.",
  Access: "Accès",
  BrokenAt: "Rupture à",
  Cases: "Dossiers",
  Checked: "Vérifiées",
  expired: "expirée",
  Games: "Jeux",
  GGR: "PBJ",
  History: "Historique",
  Locale: "Langue et région",
  Overview: "Vue d’ensemble",
  "Player cases": "Dossiers du joueur",
  "Partial snapshot": "Aperçu partiel",
  "Re-authenticate": "Confirmer l’identité",
  "Responsible gaming": "Jeu responsable",
  "Second factor": "Deuxième facteur",
  "Sign-in methods": "Méthodes de connexion",
  "Status history": "Historique des statuts",
  "Support, KYC and responsible-gaming work": "Suivi assistance, KYC et jeu responsable",
  Wallet: "Portefeuille",
  Actions: "Actions",
  "Add an immutable internal note…": "Ajouter une note interne immuable…",
  At: "Date",
  "Authenticator code": "Code d’authentification",
  "Authoritative state cannot be recovered": "L’état de référence ne peut pas être restauré",
  "Certified artifact is unavailable": "L’artefact certifié est indisponible",
  "Cool-off": "Délai de réflexion",
  "Create case": "Créer le dossier",
  false: "faux",
  "Idempotency key": "Clé d’idempotence",
  "Integrity check failed": "Échec du contrôle d’intégrité",
  Intact: "Intacte",
  "Ledger entry": "Écriture du grand livre",
  loss: "perdu",
  "Money actions waiting for a decision": "Actions financières en attente d’une décision",
  "Money flow": "Flux financier",
  "RNG chain": "Chaîne RNG",
  "Self-exclusion": "Auto-exclusion",
  "SLA due": "Échéance SLA",
  "SLA due (UTC)": "Échéance SLA (UTC)",
  stand: "rester",
  hit: "tirer une carte",
  Settlements: "Règlements",
  true: "vrai",
  Wagers: "Mises",
  "Use the available sections below": "Utilisez les sections disponibles ci-dessous",
  Unknown: "Inconnu",
  seed_mismatch: "graine incohérente",
  bet_settle: "règlement de mise",
  "Round View": "Consultation de manche",
  "At least": "Au moins",
  "characters — this is what an investigator reads later.":
    "caractères — c’est ce qu’un enquêteur lira ultérieurement.",
  "The money moves as soon as you approve.": "Les fonds sont transférés dès votre approbation.",
  "The request is closed and nothing moves.":
    "La demande est fermée et aucun fonds n’est transféré.",
  "Find a player": "Rechercher un joueur",
  "Player details": "Détails du joueur",
  No: "Non",
  On: "Activé",
  "Play stops and every live session ends. The account itself stays open.":
    "Le jeu s’arrête et toutes les sessions actives prennent fin. Le compte reste ouvert.",
  Until: "Jusqu’au",
  "Add note": "Ajouter la note",
  "Save changes": "Enregistrer les modifications",
  "Immutable Royal Spin draft created.": "Brouillon Royal Spin immuable créé.",
  "Royal Spin disabled immediately.": "Royal Spin désactivé immédiatement.",
  "Royal Spin re-enabled.": "Royal Spin réactivé.",
  draft: "brouillon",
  submitted: "soumis",
  approved: "approuvé",
  "Up to 150% Deposit Bonus": "Jusqu’à 150 % de bonus de dépôt",
  "XTS 1 / 5 / 10 Bonus": "Bonus XTS 1 / 5 / 10",
  "XTS 2 Free Bet": "Pari gratuit de 2 XTS",
  "Better Luck Tomorrow": "Plus de chance demain",
  "XTS 50 Jackpot Bonus": "Bonus jackpot de 50 XTS",
  "Extra Spin": "Tour supplémentaire",
  "authoritative state cannot be recovered": "l’état de référence ne peut pas être restauré",
  "certified artifact is unavailable": "l’artefact certifié est indisponible",
  "integrity check failed": "le contrôle d’intégrité a échoué",
  abandoned: "abandonné",
  bank: "banque",
  banned: "banni",
  blackjack: "blackjack",
  bonus_cash: "bonus",
  closed: "fermé",
  clubs: "trèfles",
  diamonds: "carreaux",
  hearts: "cœurs",
  HOUSE: "MAISON",
  in_progress: "en cours",
  live: "active",
  poker: "poker",
  rejected: "rejeté",
  resolved: "résolu",
  revoked: "révoquée",
  roulette: "roulette",
  slots: "machines à sous",
  spades: "piques",
  suspended: "suspendu",
  "Games completed and financially settled since 00:00 UTC.":
    "Jeux terminés et financièrement réglés depuis 00:00 UTC.",
  "Pending approvals. Sensitive actions waiting for review by a second operator.":
    "Approbations en attente. Actions sensibles à examiner par un second opérateur.",
  "Rounds today. Games completed and financially settled since 00:00 UTC.":
    "Manches aujourd’hui. Jeux terminés et financièrement réglés depuis 00:00 UTC.",
  "Sensitive actions waiting for review by a second operator.":
    "Actions sensibles à examiner par un second opérateur.",
  "Sensitive actions require a recent sign-in check.":
    "Les actions sensibles nécessitent une confirmation récente de votre identité.",
  "Some dashboard data could not be loaded.":
    "Certaines données du tableau de bord n’ont pas pu être chargées.",
  "Some dashboard data is unavailable": "Certaines données du tableau de bord sont indisponibles",
  "The total amount staked in games settled today.":
    "Montant total misé dans les jeux réglés aujourd’hui.",
  "Today's GGR. Gross gaming revenue is settled stakes minus player returns.":
    "PBJ du jour. Le produit brut des jeux correspond aux mises réglées moins les retours joueurs.",
  "Today's wagered. The total amount staked in games settled today.":
    "Mises du jour. Montant total misé dans les jeux réglés aujourd’hui.",
  "Player Cases View": "Consultation des dossiers joueur",
  "Player Games View": "Consultation des jeux du joueur",
  "Player Ledger View": "Consultation du grand livre du joueur",
  "Player Rg View": "Consultation du jeu responsable du joueur",
  "Player Sessions View": "Consultation des sessions du joueur",
  "Rng Chain Verify": "Vérification de la chaîne RNG",
  "Transaction View": "Consultation de transaction",
  "Artifact SHA-256": "Empreinte SHA-256 de l’artefact",
  "Clear filters": "Effacer les filtres",
  Engine: "Moteur",
  "In progress": "En cours",
  "Request reversal": "Demander l’annulation",
  "Reversal justification": "Justification de l’annulation",
  "RNG commitment": "Engagement RNG",
  "RNG reveal": "Révélation RNG",
  "Stop and escalate. Do not act on this log.":
    "Arrêtez et escaladez. N’agissez pas à partir de ce journal.",
  "This legacy round did not record a replayable final hand.":
    "Cette ancienne manche ne contient pas de main finale rejouable.",
  "Try again": "Réessayer",
  "e.g. admin.player.status": "p. ex. admin.player.status",
  "e.g. EUR": "p. ex. EUR",
  "· reverses": "· annule",
};

const ATTRIBUTES = ["aria-label", "data-label", "placeholder", "title"] as const;
const FR_SUFFIXES = Object.entries(FR).sort(([left], [right]) => right.length - left.length);

function dynamicFrench(value: string) {
  return value
    .replace(/^(\d+) entries verified$/, "$1 entrées vérifiées")
    .replace(/^(\d+) recorded$/, "$1 enregistrées")
    .replace(/^(\d+) entries shown\.$/, "$1 entrées affichées.")
    .replace(/^(\d+) accounts found\.$/, "$1 comptes trouvés.")
    .replace(/^Showing (\d+) movements$/, "$1 mouvements affichés")
    .replace(/^Showing (\d+) rounds$/, "$1 manches affichées")
    .replace(/^Showing (\d+) entries$/, "$1 entrées affichées")
    .replace(/^(\d+) requests$/, "$1 demandes")
    .replace(/^(\d+) entries$/, "$1 entrées")
    .replace(/^(\d+) min left$/, "$1 min restantes")
    .replace(/^(\d+) h left$/, "$1 h restantes")
    .replace(/^(\d+) minutes$/, "$1 minutes")
    .replace(
      /^At least (\d+) characters — this is what an investigator reads later\.$/,
      "Au moins $1 caractères — c’est ce qu’un enquêteur lira ultérieurement.",
    )
    .replace(/^round (.+) · /, "manche $1 · ")
    .replace(/^transaction (.+)$/, "transaction $1")
    .replace(/, raised by (.+)\.$/, ", demandé par $1.")
    .replace(/^Open details for /, "Ouvrir les détails de ")
    .replace(/^Open Bet settled transaction for /, "Ouvrir la transaction de mise réglée pour ")
    .replace(/^Open Bet placed transaction for /, "Ouvrir la transaction de mise placée pour ")
    .replace(/^Open Deposit transaction for /, "Ouvrir la transaction de dépôt pour ")
    .replace(/^Open audit detail for /, "Ouvrir le détail d’audit de ")
    .replace(/^Open campaign /, "Ouvrir la campagne ")
    .replace(/^Open (.+) round /, "Ouvrir la manche $1 ")
    .replace(/^Updated (.+)$/, "Mis à jour $1")
    .replace(/^Expires in (.+)$/, "Expire dans $1")
    .replace(/^Expired (.+) ago$/, "Expiré il y a $1")
    .replace(/^Chain intact across (\d+) entries\.$/, "Chaîne intacte sur $1 entrées.")
    .replace(/^Chain broken at (.+)\.$/, "Chaîne rompue à $1.")
    .replace(/^Load more$/, "Charger plus");
}

function french(value: string) {
  const leading = value.match(/^\s*/)?.[0] ?? "";
  const trailing = value.match(/\s*$/)?.[0] ?? "";
  const trimmed = value.trim();
  if (!trimmed) return value;
  const normalized = trimmed.replace(/\s+/g, " ");
  let translated = FR[normalized] ?? dynamicFrench(normalized);
  if (translated !== normalized && !(normalized in FR)) {
    const suffix = FR_SUFFIXES.find(([english]) => translated.endsWith(` ${english}`));
    if (suffix) {
      translated = `${translated.slice(0, -suffix[0].length)}${suffix[1]}`;
    }
  }
  return translated === normalized ? value : `${leading}${translated}${trailing}`;
}

export function LanguageProvider({
  children,
  language,
}: {
  children: ReactNode;
  language: Language;
}) {
  return createElement(LanguageContext.Provider, { value: language }, children);
}

export function useTranslation() {
  const language = useContext(LanguageContext);
  return (value: string) => (language === "fr" ? french(value) : value);
}

export function useLanguage() {
  return useContext(LanguageContext);
}

function translate(root: Node) {
  if (root.nodeType === Node.TEXT_NODE) {
    const text = root.nodeValue ?? "";
    const next = french(text);
    if (next !== text) root.nodeValue = next;
    return;
  }

  if (!(root instanceof Element || root instanceof DocumentFragment || root instanceof Document)) {
    return;
  }

  if (root instanceof Element) {
    for (const attribute of ATTRIBUTES) {
      const value = root.getAttribute(attribute);
      if (!value) continue;
      const next = french(value);
      if (next !== value) root.setAttribute(attribute, next);
    }
  }

  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT);
  let node = walker.nextNode();
  while (node) {
    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.nodeValue ?? "";
      const next = french(text);
      if (next !== text) node.nodeValue = next;
    } else if (node instanceof Element) {
      for (const attribute of ATTRIBUTES) {
        const value = node.getAttribute(attribute);
        if (!value) continue;
        const next = french(value);
        if (next !== value) node.setAttribute(attribute, next);
      }
    }
    node = walker.nextNode();
  }
}

export function useFrenchUi(language: Language) {
  useLayoutEffect(() => {
    if (language !== "fr") return;
    translate(document.body);

    const observer = new MutationObserver((records) => {
      for (const record of records) {
        if (record.type === "characterData") translate(record.target);
        if (record.type === "attributes") translate(record.target);
        for (const node of record.addedNodes) translate(node);
      }
    });
    observer.observe(document.body, {
      attributeFilter: [...ATTRIBUTES],
      attributes: true,
      characterData: true,
      childList: true,
      subtree: true,
    });
    return () => observer.disconnect();
  }, [language]);
}
